{
  "slug": "marie-curie-iq",
  "title": "Marie Curie IQ: what is actually known?",
  "description": "A careful review of reported Marie Curie IQ claims and why popular numbers are unverified.",
  "category": "Famous people and IQ claims",
  "sections": [
    {
      "heading": "Documented achievement",
      "paragraphs": [
        "Curie pioneered radioactivity research and received Nobel Prizes in two scientific categories.",
        "Achievement can involve knowledge, persistence, creativity, collaboration, opportunity, and specialist expertise. It cannot be translated into a unique IQ number."
      ]
    },
    {
      "heading": "Evidence behind the reported number",
      "paragraphs": [
        "Her scientific record is verifiable; a public authenticated IQ report is not. Inferring a number from awards would not meet psychometric standards.",
        "A credible claim would identify the instrument, version, date, administration conditions, norm group, score type, and a reliable primary record. Viral lists rarely provide that chain."
      ]
    },
    {
      "heading": "Responsible conclusion",
      "paragraphs": [
        "Treat a number as unverified unless a primary record is available. Separate admiration for achievement from psychometric measurement.",
        "The conclusion is not that the person lacked ability; it is that the precise number is unknown."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "iq-vs-intelligence"],
  "sources": [
    {
      "label": "Nobel Prize — Marie Curie",
      "url": "https://www.nobelprize.org/prizes/physics/1903/marie-curie/facts/"
    }
  ],
  "faqs": [
    {
      "question": "What was Marie Curie’s IQ?",
      "answer": "No authenticated standardized score is publicly established. Precise values repeated online should be treated as speculation."
    },
    {
      "question": "Can achievement be converted into IQ?",
      "answer": "No. Achievement and test performance overlap only partly and use different evidence."
    }
  ],
  "summary": "A careful review of reported Marie Curie IQ claims and why popular numbers are unverified. Content reviewed 18 July 2026."
}
